"use client";
import React, { useEffect } from "react";
import PropTypes from "prop-types";
import cn from "classnames";
import axios from "axios";

import isInIframe from "@/next-src/utils/isInIframe";
import getErrorMsg from "@/next-src/utils/getErrorMsg";

import comCSS from "./AppSession.module.scss";

const AppSession = ({ className = "" }) => {
  useEffect(() => {
    if (isInIframe()) {
      const onMessage = async (e) => {
        if (
          e.origin !== process.env.ADMIN_DOMAIN ||
          e.data.type !== "userEmail" ||
          !e.data.email
        )
          return;

        try {
          await axios({
            method: "POST",
            data: e.data,
            url: "/api/login",
          });
        } catch (error) {
          const errMsg = getErrorMsg(error);
          console.log("error", errMsg);
          return;
        }

        let token = null;
        try {
          const res = await axios({
            method: "get",
            params: { email: e.data.email },
            url: "/api/user",
          });
          token = res.headers["authorization"];
        } catch (error) {
          const errMsg = getErrorMsg(error);
          console.log("error", errMsg);
          return;
        }

        window.parent.postMessage(
          {
            type: "token",
            message: token,
          },
          process.env.ADMIN_DOMAIN
        );
      };
      window.addEventListener("message", onMessage);
      return () => window.removeEventListener("message", onMessage);
    }
  }, []);
  return <div className={cn(className, comCSS.wrapper)} />;
};

AppSession.propTypes = {
  className: PropTypes.string,
};

export default AppSession;
